// extracted by mini-css-extract-plugin
module.exports = {"modal":"ManageExternalUser_modal_13o3N"};